import styled from 'styled-components'

interface PriceStrongProps {
    strong: boolean,
    color?: string
}

export const PriceStrong = styled.span<PriceStrongProps>`
  font-weight: ${(props) => props.strong ? 'bold' : 'unset'};
  color: ${(props) => props.color ? props.color : 'unset'};
`

export const PriceContainer = styled.span`
  word-wrap: break-word;
`